import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _TakeProgress;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@instructure/ui-text';
import { ProgressBar } from '@instructure/ui-progress';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/es/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var TakeProgress = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_TakeProgress = /*#__PURE__*/function (_Component) {
  function TakeProgress() {
    _classCallCheck(this, TakeProgress);
    return _callSuper(this, TakeProgress, arguments);
  }
  _inherits(TakeProgress, _Component);
  return _createClass(TakeProgress, [{
    key: "render",
    value: function render() {
      return jsx("div", {
        css: this.props.styles.root
      }, jsx(ProgressBar, {
        size: "small",
        screenReaderLabel: t('Quiz Progress'),
        formatScreenReaderValue: this.formatScreenReaderValue,
        renderValue: this.renderValue,
        valueNow: this.props.currentQuestionPosition,
        valueMax: this.props.totalQuestionCount
      }));
    }
  }, {
    key: "formatScreenReaderValue",
    value: function formatScreenReaderValue(_ref) {
      var valueNow = _ref.valueNow,
        valueMax = _ref.valueMax;
      return t('{currentPosition, number} of {totalQuestionCount, number} questions', {
        currentPosition: valueNow,
        totalQuestionCount: valueMax
      });
    }
  }, {
    key: "renderValue",
    value: function renderValue(_ref2) {
      var valueNow = _ref2.valueNow,
        valueMax = _ref2.valueMax;
      var positionText = t('{currentPosition, number} / {totalQuestionCount, number}', {
        currentPosition: valueNow,
        totalQuestionCount: valueMax
      });
      return jsx("span", null, jsx(Text, {
        size: "small"
      }, positionText));
    }
  }]);
}(Component), _defineProperty(_TakeProgress, "displayName", 'TakeProgress'), _defineProperty(_TakeProgress, "componentId", "Quizzes".concat(_TakeProgress.displayName)), _defineProperty(_TakeProgress, "propTypes", {
  currentQuestionPosition: PropTypes.number.isRequired,
  totalQuestionCount: PropTypes.number.isRequired,
  styles: PropTypes.object
}), _TakeProgress)) || _class);
export default TakeProgress;